import { motion } from "framer-motion";
import { Construction } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function MaintenanceOverlay() {
  const { t } = useTranslation();

  return (
    <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100">
      <motion.div
        className="flex flex-col items-center gap-6 p-10 max-w-md text-center"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <motion.div
          className="flex items-center justify-center w-20 h-20 rounded-full bg-amber-50 border border-amber-200"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5, delay: 0.2, type: "spring", stiffness: 200 }}
        >
          <Construction className="w-10 h-10 text-amber-500" strokeWidth={1.5} />
        </motion.div>

        <motion.h1
          className="text-2xl font-semibold text-slate-800 tracking-tight"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          {t("maintenance.title")}
        </motion.h1>

        <motion.p
          className="text-base text-slate-500 leading-relaxed"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.6 }}
        >
          {t("maintenance.message")}
        </motion.p>
      </motion.div>
    </div>
  );
}
